module.exports = __webpack_public_path__ + "img/icon_share_8.23599a66.png";